const requisitionType = {
  SETMODAL: 'SETMODAL',
  SETINTERVIEWS: 'SETINTERVIEWS',
  SETAPPLICANTS: 'SETAPPLICANTS',
  SETFILTERS: 'SETFILTERS',
  CLEARFILTERS: 'CLEARFILTERS',
  SETUPDATEDSTAGE: 'SETUPDATEDSTAGE',
  SETSELECTEDINTERVIEW: 'SETSELECTEDINTERVIEW',
  SETRECRUITERS: 'SETRECRUITERS',
  SETSTAGE: 'SETSTAGE',
  SETMODALFOOTER: 'SETMODALFOOTER',
  SETAPPLICANTLISTURL: 'SETAPPLICANTLISTURL',
  REFRESHLIST: 'REFRESHLIST',
  SETUPDATEDNOTE: 'SETUPDATEDNOTE',
  SET_BULK_ITEMS: 'SET_BULK_ITEMS',
  SET_BULK_ACTION: 'SET_BULK_ACTION',
  SET_CHANGED_INTERVIEWS: 'SET_CHANGED_INTERVIEWS',
}

export default requisitionType
